import { render, staticRenderFns } from "./TabCollection.vue?vue&type=template&id=d9d82904"
import script from "./TabCollection.vue?vue&type=script&lang=js"
export * from "./TabCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports